/**
 * Short notification chime via Web Audio (no asset file).
 */

const SOUND_PREF_KEY = 'mboss.client.notifications.soundEnabled';

let ctx = null;

function ensureCtx() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
  return ctx;
}

export function unlockNotificationAudio() {
  ensureCtx();
}

export function isNotificationSoundEnabled() {
  try {
    const raw = localStorage.getItem(SOUND_PREF_KEY);
    if (raw === null) return true;
    return raw === '1' || raw === 'true';
  } catch (_) {
    return true;
  }
}

export function setNotificationSoundEnabled(enabled) {
  try {
    localStorage.setItem(SOUND_PREF_KEY, enabled ? '1' : '0');
  } catch (_) {
    /* ignore */
  }
}

export function playNotificationSound(opts = {}) {
  if (!isNotificationSoundEnabled()) return;
  const audio = ensureCtx();
  if (!audio) return;

  const severity = String(opts.severity || 'info').toLowerCase();
  const baseFreq = severity === 'critical' ? 880 : severity === 'warning' ? 660 : 523;
  const volume = severity === 'critical' ? 0.12 : 0.08;

  try {
    const now = audio.currentTime;
    const osc = audio.createOscillator();
    const gain = audio.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(baseFreq, now);
    osc.frequency.setValueAtTime(baseFreq * 1.25, now + 0.09);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(volume, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.28);
    osc.connect(gain);
    gain.connect(audio.destination);
    osc.start(now);
    osc.stop(now + 0.3);
  } catch (_) {
    /* ignore */
  }
}
